export const clearNativeInput = (element: HTMLInputElement | HTMLTextAreaElement): void => {
  const prototype = element instanceof HTMLTextAreaElement ? HTMLTextAreaElement.prototype : HTMLInputElement.prototype;
  Object.getOwnPropertyDescriptor(prototype, 'value')?.set?.call(element, '');
  element.dispatchEvent(new Event('input', { bubbles: true }));
};
